<template>
    <div class="expense-content">
        <el-card class="box-card">
            <div class="table-box">
                <div class="card-title">资源名称:</div>
                <el-input v-model="header.resourceName" class="handle-input" placeholder="请输入渠道名称"></el-input>
            </div>
            <div class="table-box">
                <div class="card-title">用户类型:</div>
                <!-- <el-input v-model="header.contact" class="handle-input" placeholder="请输入联系方式"></el-input> -->
                <el-select v-model="header.userType" placeholder="请选择用户类型">
                    <el-option label="普通用户" value="1"></el-option>
                    <el-option label="公司用户" value="2"></el-option>
                </el-select>
            </div>
            <el-button type="primary" icon="el-icon-search" @click="getSearchData">搜 索</el-button>
        </el-card>
        <el-card class="box-card mt20">
            <el-table
                :data="tableData"
                border
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
            >
                <el-table-column label="订单ID" min-width="150">
                    <template slot-scope="{row}">
                        
                        <el-link type="primary" >{{row.orderId}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="resourceName" label="资源名称"></el-table-column>
                <el-table-column prop="userName" label="用户名称"></el-table-column>
                <el-table-column prop="userType" label="用户类型">
                    <template slot-scope="{row}">
                        <span v-if="row.userType === 1">普通用户</span>
                        <span v-if="row.userType === 2">公司用户</span>
                    </template>
                </el-table-column>
                <el-table-column prop="orderAmount" label="订单金额"></el-table-column>
                <el-table-column label="渠道提成">
                    <template slot-scope="{row}">
                        {{row.channelCommission}}%
                    </template>
                </el-table-column>
                <el-table-column prop="channelAmount" label="渠道佣金"></el-table-column>
                <el-table-column prop="insertTime" label="创建时间"></el-table-column>
                
                
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="query.currentPage"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="query.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="query.total">
                </el-pagination>
            </div>
        </el-card>
        
    </div>
</template>

<script>
import {
    channelUserIncomeList
} from '@/api/index'
export default {

    data() {
        return {
            header:{
                channelName:'',
                contact:''
            },
            tableData:[],
            query:{
                currentPage:1,
                pageSize:10,
                total:0,
            },
        };
    },

    mounted() {
        this.getListData();
    },

    methods: {
        getSearchData(){
            this.query.currentPage = 1;
            this.getListData()
        },
        async getListData(){
            let data = {
                pageNum:this.query.currentPage,
                pageSize:this.query.pageSize,
                resourceName:this.header.contact,
                userType:this.header.channelName,
            }
            const res = await channelUserIncomeList(data)
            if(res.success){
                this.tableData = res.data.records
                this.query.total = res.data.total
            }
        },
        handleSizeChange(val) {
            this.query.pageSize = val;
            this.getListData();
        },
        handleCurrentChange(val) {
            this.query.currentPage = val;
            this.getListData();
        },
    },
};
</script>

<style scoped>
.expense-content{
    width:100%;
    height:auto;
    min-height:calc(100vh - 200px);
	padding:20px 20px;
	background-color: #f9fafb;
}
.table-box{
    display:inline-block;
    margin-right:10px;
}
.card-title{
    display:inline-block;
    margin-right:10px;
    font-size:14px;
    line-height:40px;
}
.handle-input{
    width:240px;
}

</style>